import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import ScrollToTop from "./components/ScrollToTop";
import AuthenticationRouter from "./components/navigation/AuthenticationRouter";

import NotFound from "./pages/NotFound";
import LandingPage from "./pages/landing-page";
import AuthenticationHub from "./pages/authentication-hub";
import OnboardingFlow from "./pages/onboarding-flow";
import PatientManagement from "./pages/patient-management";
import ScheduleDashboard from "./pages/schedule-dashboard";
import ProfileEditingScreen from "./pages/profile-editing-screen";
import PublicPatientBookingScreen from "./pages/public-patient-booking-screen";
import PublicBookingUrlManagementScreen from "./pages/public-booking-url-management-screen";
import NotificationSettingsScreen from 'pages/notification-settings-screen';
import EmailConfirmation from "./pages/email-confirmation";
import ZAPIWebhookHandler from "./pages/webhook-zapi";
import SubscriptionManagementScreen from "./pages/subscription-management-screen";
import { SubscriptionRouter } from './components/SubscriptionRouter';

export default function Routes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/authentication-hub" element={<AuthenticationHub />} />
          <Route path="/email-confirmation" element={<EmailConfirmation />} />
          <Route path="/public-patient-booking-screen/:psychologistId" element={<PublicPatientBookingScreen />} />
          
          {/* ZAPI Webhook Endpoint - Public route to receive webhook POST requests */}
          <Route path="/webhook-zapi" element={<ZAPIWebhookHandler />} />

          {/* Protected Routes */}
          <Route 
            path="/onboarding-flow" 
            element={
              <AuthenticationRouter>
                <OnboardingFlow />
              </AuthenticationRouter>
            } 
          />
          <Route 
            path="/profile-management" 
            element={
              <AuthenticationRouter>
                <SubscriptionRouter>
                  <ProfileEditingScreen />
                </SubscriptionRouter>  
              </AuthenticationRouter>
            } 
          />
          <Route 
            path="/patient-management" 
            element={
              <AuthenticationRouter>
                <SubscriptionRouter>
                  <PatientManagement />
                </SubscriptionRouter>                  
              </AuthenticationRouter>
            } 
          />
          <Route 
            path="/schedule-dashboard" 
            element={
              <AuthenticationRouter>
                <SubscriptionRouter>                
                  <ScheduleDashboard />
                </SubscriptionRouter>  
              </AuthenticationRouter>
            } 
          />
          <Route 
            path="/public-booking-url-management-screen" 
            element={
              <AuthenticationRouter>
                <SubscriptionRouter>
                  <PublicBookingUrlManagementScreen />
                </SubscriptionRouter>
              </AuthenticationRouter>
            } 
          />
          
          {/* Notification Settings Route */}
          <Route
            path="/notification-settings-screen"
            element={
              <AuthenticationRouter>
                <SubscriptionRouter>
                  <NotificationSettingsScreen />
                </SubscriptionRouter>
              </AuthenticationRouter>
            }
          />

          {/* Subscription Management Route */}
          <Route 
            path="/subscription-management-screen" 
            element={
              <AuthenticationRouter>
                <SubscriptionManagementScreen />
              </AuthenticationRouter>
            } 
          />

          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}